<template>
    <div class="hero-software hero-swiper-btn" id="home">
        <div class="container_f1">
            <div class="swiper-wrapper">
                <swiper :options="swiperOption">
<!--                    <div class="swiper-slide" :style="bgImg">-->
                    <div class="swiper-slide">
                      <div class="hero-item">
                              <div class="hero-content">
<!--                          <div class="hero-content" style="width: 850px;">-->
                              <h1 class="hero-content-title">
                                <strong style="color:#0f306e">vos </strong>
                                <strong style="color:#b6802e">pieds </strong>
                                <br>
                                <strong style="color:#0f306e">notre </strong>
                                <strong style="color:#b6802e">compétence </strong>
                              </h1>
                              <h6 class="hero-slogan-services-pied-prod">
                                <p>
                                  Ongles incarnés<i class="fas fa-circle text-service-separator"></i>
                                  <i style="font-style: normal; color: #9b9b9b">Verrues plantaires</i> <i class="fas fa-circle text-service-separator"></i>Douleur aux pieds
                                </p>
                                <p>
                                  <i style="font-style: normal; color: #9b9b9b">Transpiration excessive</i>
                                  <i class="fas fa-circle text-service-separator"></i>Pieds Diabétiques
                                  <i class="fas fa-circle text-service-separator"></i>
                                  <i style="font-style: normal; color: #9b9b9b">Soins des pieds</i>
                                </p>
                                <p>
                                  <i style="font-style: normal; color: #9b9b9b">Orthèses plantaires sur mesure</i>
                                </p>
                              </h6>
<!--                                <router-link :to="{ path: 'branding' }" class="btn btn&#45;&#45;green">-->
<!--                                    <span class="btn-icon  ml-0 mr-2"><i class="fa fa-arrow-alt-to-bottom"></i></span> Get AeroLand-->
<!--                                </router-link>-->
                            </div>
                            <div class="hero-thumb pr-100">
<!--                                <img src="@/assets/img/hero/hero-software/software-thumb-1.png" class="img-fluid" alt="hero thumb">-->
                              <img class="portrait" alt="Dr Rita El-Khoury - podiatre" src="../../assets/img/pied-pro/Dr_Rita_El-Khoury_Podiatre.png">

                            </div>
                        </div>
                    </div>
<!--                    <div class="swiper-slide" :style="bgImg">-->
<!--                        <div class="hero-item">-->
<!--                            <div class="hero-content">-->
<!--                                <h2 class="h1 hero-content-title">Better software promotes sales & profits</h2>-->
<!--                                <h6 class="hero-content-subtitle">AeroLand doesn't require users to be experts.</h6>-->
<!--                                <router-link :to="{ path: 'branding' }" class="btn btn&#45;&#45;green">-->
<!--                                    <span class="btn-icon  ml-0 mr-2"><i class="fa fa-arrow-alt-to-bottom"></i></span> Get AeroLand-->
<!--                                </router-link>-->
<!--                            </div>-->
<!--                            <div class="hero-thumb">-->
<!--                                <img src="@/assets/img/hero/hero-software/software-thumb-2.png" class="img-fluid" alt="hero thumb">-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="swiper-slide" :style="bgImg">-->
<!--                        <div class="hero-item">-->
<!--                            <div class="hero-content">-->
<!--                                <h2 class="h1 hero-content-title">Your business deserves better software</h2>-->
<!--                                <h6 class="hero-content-subtitle">No coding skills required to create unique sites.</h6>-->
<!--                                <router-link :to="{ path: 'branding' }" class="btn btn&#45;&#45;green">-->
<!--                                    <span class="btn-icon  ml-0 mr-2"><i class="fa fa-arrow-alt-to-bottom"></i></span> Get AeroLand-->
<!--                                </router-link>-->
<!--                            </div>-->
<!--                            <div class="hero-thumb pr-100">-->
<!--                                <img src="@/assets/img/hero/hero-software/software-thumb-3.png" class="img-fluid" alt="hero thumb">-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    &lt;!&ndash; Optional controls &ndash;&gt;-->
<!--                    <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>-->
<!--                    <div class="swiper-button-next swiper-button-white" slot="button-next"></div>-->
                </swiper>
            </div>
            <div class="row" style=" background-color:#0f306e; display: inherit; padding: 20px; margin: 0px;">
              <!--        <div class="row" style=" background-color:#0f306e; display: inherit; padding: 20px; height: calc(100% - 100px);">-->
              <div class="col-12 text-right h5 text-white" >
                Dre Rita El-Khoury, podiatre
              </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                bgImg: {
                    backgroundImage: `url(${require("@/assets/img/hero/hero-software/software-shape.png")})`
                },
                swiperOption: {
                    speed: 1500,
                    loop: true,
                    effect: 'fade',
                    autoplay: false,
                    spaceBetween : 30,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                }
            };
        }
    };
</script>

<style lang="scss" scoped> 
    @import '../../assets/scss/variabls.scss';
    @import '../../assets/scss/elements/hero-software.scss';
</style>
